// extracted by mini-css-extract-plugin
export default {"base":"FeedbackView__base___wsCSn"};